import React from 'react';
import KcChart from '../../../../../../components/Highcharts/KcChart/KcChart';
import RadiationChart from '../../../../../../components/Highcharts/LineCharts/RadiationChart/RadiationChart';
import useStyles from '../../../../../../components/Highcharts/styles';
import useResponsiveChartHeight from '../../../../../../hooks/useResponsiveChartHeight';
import WindChart from '../../../../../../components/Highcharts/LineCharts/WindChart/WindChart';
import DpvChart from '../../../../../../components/Highcharts/LineCharts/DpvChart/DpvChart';
import HumidityTemperatureChart from '../../../../../../components/Highcharts/LineCharts/HumidityTemperatureChart/HumidityTemperatureChart';
import Et0IrrigationChart from '../../../../../../components/Highcharts/Et0Irrigation/Et0IrrigationChart';
import RainfallChart from '../../../../../../components/Highcharts/RainfallChart/RainfallChart';

function WeatherDashboard({
  sectorId,
  farmId,
}: {
  sectorId: string,
  farmId: string,
}) {
  const classes = useStyles();
  const {
    minionChartHeight, smallChartHeight,
  } = useResponsiveChartHeight();

  return (
    <div className={classes.dashboardContainer}>
      <Et0IrrigationChart
        chartView="dashboard"
        hideLegend={false}
        hideYValues={false}
        hideXValues={true}
        sectorId={sectorId}
        farmId={farmId}
        height={smallChartHeight}
        yAxisTitle=""
        title="ETo + Riego"
      />
      <KcChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={minionChartHeight}
        title="Kc"
        yAxisTitle=""
      />
      <RainfallChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={smallChartHeight}
        yAxisTitle=""
        title="Precipitaciones"
      />
      <RadiationChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={smallChartHeight}
        yAxisTitle=""
        title="Radiación solar"
      />
      <WindChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        height={smallChartHeight}
        farmId={farmId}
        yAxisTitle=""
      />
      <DpvChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        height={smallChartHeight}
        farmId={farmId}
        yAxisTitle=""
      />
      <HumidityTemperatureChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        height={smallChartHeight}
        farmId={farmId}
        yAxisTitle=""
      />
    </div>
  );
}

export default WeatherDashboard;
